import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { tableStyles } from '../core/table-utils';
import { theme } from '../core/theme';
import { tokens } from '../core/tokens';

export const StyledTableDataDiv = styled.div`
   display: flex;
   align-items: center;
   white-space: normal;
   word-break: normal;
   overflow-wrap: break-word;
`;

export const StyledTableHeader = styled.th<{ width?: string }>`
   ${(props) => css`
      width: ${props.width};
      min-width: ${props.width};
      max-width: ${props.width};
   `}
   cursor: pointer;
   white-space: normal;
   word-break: normal;
   overflow-wrap: break-word;
`;

export const StyledTh = styled.th`
   ${tableStyles.headerBase};
   padding-bottom: ${tokens.space.md} !important;
   text-align: left;
`;

export const StyledTd = styled.td`
   ${tableStyles.cellBase};
   text-align: right;
   padding-right: 25%;
`;

export const StyledTableRow = styled.tr<{ noHover?: boolean; boldFont?: boolean }>`
   ${(props) => {
      let returnStyles = css``;
      if (!props.noHover)
         returnStyles = css`
            :hover {
               background-color: ${theme.colors.bg.secondary};
            }
         `;
      if (props.boldFont)
         returnStyles = css`
            ${returnStyles};
            font-weight: ${tokens.font.weight.semibold};
         `;
      return returnStyles;
   }}
   width: 100%;

   th:first-of-type {
      padding-left: ${tokens.space.md};
      padding-top: ${tokens.space.sm};
      padding-bottom: ${tokens.space.xs} !important;
   }

   td {
      border: none;
      border-bottom: ${tokens.border.thin} ${theme.colors.border.default};
   }
`;

export const StyledTableData = styled.td`
   :first-of-type {
      padding-inline-start: 0;
      padding-right: 0;
      max-width: ${tokens.space.xl};
   }

   &th :first-of-type {
      padding-left: ${tokens.font.size['3xl']};
      max-width: ${tokens.space.xl};
   }

   padding-top: ${tokens.space.lg} !important;
   padding-bottom: ${tokens.space.lg} !important;

   .table & {
      vertical-align: middle;
   }
`;
